import React from 'react';
import { StepHeaderStyled, StepInfoStyled, StepTitleStyled } from './styles';
import {
  PROPOSAL_GEN_STEP_HEADER_INFO_TEST_ID,
  PROPOSAL_GEN_STEP_HEADER_TEST_ID,
  PROPOSAL_GEN_STEP_HEADER_TITLE_TEST_ID,
} from '../constants';

interface StepHeaderProps {
  title: string;
  info: string;
  noBorder?: boolean;
}

const ProposalGenerationStepHeader: React.FC<StepHeaderProps> = ({ title, info, noBorder = false }) => {
  return (
    <StepHeaderStyled $noBorder={noBorder} data-test-id={PROPOSAL_GEN_STEP_HEADER_TEST_ID}>
      <StepTitleStyled data-test-id={PROPOSAL_GEN_STEP_HEADER_TITLE_TEST_ID}>{title}</StepTitleStyled>
      <StepInfoStyled data-test-id={PROPOSAL_GEN_STEP_HEADER_INFO_TEST_ID}>{info}</StepInfoStyled>
    </StepHeaderStyled>
  );
};

export default ProposalGenerationStepHeader;
